import moment from 'moment';

const getTodayMoment = () => moment.utc();
const getYesterdayMoment = () => moment.utc().subtract(1, 'days');

const getDatePresets = () => {
  const today = getTodayMoment();
  const yesterday = getYesterdayMoment();
  return [
    {
      name: 'today',
      label: 'Today',
      startDate: today,
      endDate: today,
    },
    {
      name: 'yesterday',
      label: 'Yesterday',
      startDate: yesterday,
      endDate: yesterday,
    },
    {
      name: 'last3days',
      label: 'Last 3 days',
      startDate: moment.utc().subtract(2, 'days'),
      endDate: today,
    },
    {
      name: 'last7days',
      label: 'Last 7 days',
      startDate: moment.utc().subtract(6, 'days'),
      endDate: today,
    },
    {
      name: 'thisMonth',
      label: 'This month',
      startDate: moment.utc().startOf('month'),
      endDate: today,
    },
    {
      name: 'last30days',
      label: 'Last 30 days',
      startDate: moment.utc().subtract(29, 'days'),
      endDate: today,
    },
    {
      name: 'lastMonth',
      label: 'Last month',
      startDate: moment.utc().subtract(1, 'months').startOf('month'),
      endDate: moment.utc().subtract(1, 'months').endOf('month'),
    },
  ];
};

export { getTodayMoment, getYesterdayMoment, getDatePresets };
